module.exports = __webpack_public_path__ + "img/upper_pocket_length.56f4acaa.png";